<template>
    <button
        :disabled="disabled"
        @click="clicked"
    >
        <slot />
        <transition-group
                name="fade"
                mode="out-in"
        >
            <i
                v-if="loading"
                key="spinner"
                class="fas fa-spinner fa-spin"
            />
            <i
                v-if="!loading && hasArrow"
                key="arrow"
                class="far fa-long-arrow-right"
            />
        </transition-group>
    </button>
</template>
<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: [Boolean, String],
            default: false,
        },
        handleEnter: {
            type: [Boolean, String],
            default: false,
        },
        hasArrow: {
            type: Boolean,
            default: false,
        },
    },

    /**
     * Mounted hook
     */
    mounted() {
        if (this.handleEnter) {
            window.addEventListener('keyup', this.enterHandler);
        }
    },

    /**
     * Before destroy hook
     */
    beforeDestroy() {
        if (this.handleEnter) {
            window.removeEventListener('keyup', this.enterHandler);
        }
    },

    methods: {
        /**
         * Emit click event.
         *
         */
        clicked() {
            if (! this.loading) {
                this.$emit('click');
            }
        },

        /**
         * Handle enter key
         *
         * @param {event} event DOM event.
         */
        enterHandler(event) {
            if (13 === event.keyCode) {
                this.$emit('click');
            }
        },
    },
};
</script>
